import {
	OctAutocomplete,
	OctDatePickerCustom,
	OctInputSearch,
	OctLabel,
	OctTextField
} from "@oceantech/oceantech-ui";
import { ChangeEvent, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import OctPopover from "../../component/popover";
import {
	APP_TIMESTAMP_FORMAT,
	DEFAULT_PAGE_INDEX,
	DEFAULT_PAGE_SIZE
} from "../../utils/Constant";
import { formatDateTime } from "../../utils/FormatUtils";
import { getDepartments } from "../../utils/ServicesUtils";
import AddMedicalRecordButton from "./AddMedicalRecordButton";
import SearchBadge from "./SearchBadge";

type Props = {
	onSearch: (query: any) => void;
};

const Filter = ({ onSearch }: Props) => {
	const [value, setValue] = useState<any>({});

	const keywordRef = useRef("");

	const handleSearch = () => {
		const { falculity, department, statusDiagram, ...otherValue } = value ?? {};

		onSearch({
			...otherValue,
			keyword: keywordRef.current || null,
			fullName: value?.fullName || null,
			departmentCode: value?.department?.code || value?.falculity?.code || null,
			departmentName: value?.department?.name || value?.falculity?.name || null,
			statusDiagramCode: value?.statusDiagram?.code || null,
			visitDateStarted: formatDateTime(value?.visitDateStarted, APP_TIMESTAMP_FORMAT),
			visitDateStopped: formatDateTime(value?.visitDateStopped, APP_TIMESTAMP_FORMAT),
			createdDate: formatDateTime(value?.createdDate, APP_TIMESTAMP_FORMAT),
			modifiedDate: formatDateTime(value?.modifiedDate, APP_TIMESTAMP_FORMAT),
		});
	};

	return (
		<div className="d-flex justify-content-end spaces py-8 gap-8">
			<div className="w-25">
				<OctInputSearch
					onChange={(inputValue) => {
						if (inputValue === keywordRef.current) return;
						keywordRef.current = inputValue;
						handleSearch();
					}}
					handleSearch={() => {
						handleSearch();
					}}
					placeholder="Tìm kiếm theo mã hồ sơ"
				/>
			</div>
			<OctPopover
				buttonProps={{
					className: "btn-fill",
					children: <SearchBadge query={value} />,
				}}
				overlayProps={{
					placement: "bottom",
				}}
				popoverProps={{
					style: {
						minWidth: "30vw",
					},
				}}
			>
				<div className="flex-column spaces gap-4">
					<Row>
						<Col>
							<OctLabel label="Tên bệnh nhân" />
							<OctTextField
								name="fullName"
								value={value?.fullName}
								onChange={(e: ChangeEvent<HTMLInputElement>) => {
									setValue({
										...value,
										fullName: e.target.value,
									});
								}}
							/>
						</Col>
					</Row>
					<Row>
						<Col>
							<OctLabel label="Khoa" />
							<OctAutocomplete
								options={[]}
								searchFunction={getDepartments}
								searchObject={{
									pageIndex: DEFAULT_PAGE_INDEX,
									pageSize: DEFAULT_PAGE_SIZE,
									level: 1,
								}}
								isScroll
								name="falculity"
								urlData="data.content"
								value={value?.falculity}
								onChange={(selectedOption) => {
									setValue({
										...value,
										falculity: selectedOption,
									});
								}}
							/>
						</Col>
						<Col>
							<OctLabel label="Phòng" />
							<OctAutocomplete
								options={[]}
								searchFunction={getDepartments}
								searchObject={{
									pageIndex: DEFAULT_PAGE_INDEX,
									pageSize: DEFAULT_PAGE_SIZE,
									level: 2,
									parentCode: value?.falculity?.code,
								}}
								isScroll
								urlData="data.content"
								name="department"
								value={value?.department}
								onChange={(selectedOption) => {
									setValue({
										...value,
										department: selectedOption,
									});
								}}
								dependencies={[value?.falculity?.code]}
								isDisabled={!value?.falculity?.code}
							/>
						</Col>
					</Row>
					<Row>
						<Col>
							<OctLabel label="Ngày vào viện" />
							<OctDatePickerCustom
								name="visitDateStarted"
								value={value?.visitDateStarted}
								onChange={(dateValue) => {
									setValue({
										...value,
										visitDateStarted: dateValue,
									});
								}}
								maxDate={new Date()}
								popperPlacement="left"
							/>
						</Col>
						<Col>
							<OctLabel label="Ngày ra viện" />
							<OctDatePickerCustom
								name="visitDateStopped"
								value={value?.visitDateStopped}
								onChange={(dateValue) => {
									setValue({
										...value,
										visitDateStopped: dateValue,
									});
								}}
								maxDate={new Date()}
								popperPlacement="left"
							/>
						</Col>
					</Row>
					<Row>
						<Col>
							<OctLabel label="Ngày tạo" />
							<OctDatePickerCustom
								name="createdDate"
								value={value?.createdDate}
								onChange={(dateValue) => {
									setValue({
										...value,
										createdDate: dateValue,
									});
								}}
								maxDate={new Date()}
								popperPlacement="left"
							/>
						</Col>
						<Col>
							<OctLabel label="Ngày cập nhật" />
							<OctDatePickerCustom
								name="modifiedDate"
								value={value?.modifiedDate}
								onChange={(dateValue) => {
									setValue({
										...value,
										modifiedDate: dateValue,
									});
								}}
								maxDate={new Date()}
								popperPlacement="left"
							/>
						</Col>
					</Row>
					<Row>
						<Col>
							<OctLabel label="Trạng thái hồ sơ" />
							<OctAutocomplete
								options={[]}
								name="statusDiagram"
								value={value?.statusDiagram}
								onChange={(selectedOption) => {
									setValue({
										...value,
										statusDiagram: selectedOption,
									});
								}}
							/>
						</Col>
					</Row>
					<div className="d-flex justify-content-center spaces gap-4 mt-8">
						<Button
							className="btn-danger spaces px-16"
							onClick={() => {
								setValue(null);
							}}
						>
							Làm mới
						</Button>
						<Button
							className="btn-fill spaces px-16"
							onClick={() => {
								handleSearch();
							}}
						>
							Lọc
						</Button>
					</div>
				</div>
			</OctPopover>
			<AddMedicalRecordButton />
		</div>
	);
};

export default Filter;
